module.exports = __webpack_public_path__ + "static/logo-9238c2f3de47ce213236e7bafab8da2a.png";